"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderers = void 0;
var react_1 = require("react");
var createDefaultRenderers_1 = require("./createDefaultRenderers");
var useRenderers = function (_a) {
    var renderItem = _a.renderItem, renderItemTitle = _a.renderItemTitle, renderRenameInput = _a.renderRenameInput, renderDraggingItem = _a.renderDraggingItem, renderDraggingItemTitle = _a.renderDraggingItemTitle, renderItemsContainer = _a.renderItemsContainer, renderTreeContainer = _a.renderTreeContainer, renderSearchInput = _a.renderSearchInput, renderLiveDescriptorContainer = _a.renderLiveDescriptorContainer, renderDepthOffset = _a.renderDepthOffset;
    var defaultRenderers = (0, react_1.useMemo)(function () { return (0, createDefaultRenderers_1.createDefaultRenderers)(renderDepthOffset !== null && renderDepthOffset !== void 0 ? renderDepthOffset : 10); }, [renderDepthOffset]);
    var customRenderers = {
        renderItem: renderItem,
        renderItemTitle: renderItemTitle,
        renderRenameInput: renderRenameInput,
        renderDraggingItem: renderDraggingItem,
        renderDraggingItemTitle: renderDraggingItemTitle,
        renderItemsContainer: renderItemsContainer,
        renderTreeContainer: renderTreeContainer,
        renderSearchInput: renderSearchInput,
        renderLiveDescriptorContainer: renderLiveDescriptorContainer,
        renderDepthOffset: renderDepthOffset,
    };
    var renderers = Object.entries(defaultRenderers).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        var keyMapped = key;
        if (customRenderers[keyMapped]) {
            acc[keyMapped] = customRenderers[keyMapped];
        }
        else {
            acc[keyMapped] = value;
        }
        return acc;
    }, {});
    renderers.renderItem.displayName = 'RenderItem';
    renderers.renderItemTitle.displayName = 'RenderItemTitle';
    renderers.renderRenameInput.displayName = 'RenderRenameInput';
    renderers.renderDraggingItem.displayName = 'RenderDraggingItem';
    renderers.renderDraggingItemTitle.displayName =
        'RenderDraggingItemTitle';
    renderers.renderItemsContainer.displayName = 'RenderItemsContainer';
    renderers.renderTreeContainer.displayName = 'RenderTreeContainer';
    renderers.renderSearchInput.displayName = 'RenderSearchInput';
    return renderers;
};
exports.useRenderers = useRenderers;
